var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"course-creater-header-step"},[_c('el-steps',{attrs:{"active":_vm.active,"finish-status":"success","align-center":""}},[_c('el-step',{attrs:{"title":"课题名称"}}),_c('el-step',{attrs:{"title":"筛选课题数据"}}),_c('el-step',{attrs:{"title":"完成创建课题"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }